module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.c9f7f5fb.otf";